import React from "react";
import LoadingFixtureSelection from "./components/LoadingFixtureSelection";
import styles from "./FilterFixturesLoadingSkeleton.module.scss";

const FilterFixturesLoadingSkeleton = () => {
  return (
    <div className={styles.filterFixturesLoadingSkeleton}>
      <div>
        <div className={styles.filterFixturesLoadingText} />
        <LoadingFixtureSelection />
        <LoadingFixtureSelection />
      </div>
      <div>
        <div className={styles.filterFixturesLoadingText} />
        <LoadingFixtureSelection />
        <LoadingFixtureSelection />
      </div>
      <div>
        <div className={styles.filterFixturesLoadingText} />
        <LoadingFixtureSelection />
      </div>
      <div>
        <div className={styles.filterFixturesLoadingText} />
        <LoadingFixtureSelection />
        <LoadingFixtureSelection />
      </div>
      <div>
        <div className={styles.filterFixturesLoadingText} />
        <LoadingFixtureSelection />
      </div>
      <div>
        <div className={styles.filterFixturesLoadingText} />
        <LoadingFixtureSelection />
      </div>
    </div>
  );
};

export default FilterFixturesLoadingSkeleton;
